import api from './api';
import type { BilltoOpt, CustomerOpt, BrokerOpt } from './contstatusreport.service';

/**
 * EDI Document Setup (cms.edi_document_setup) — options + the Document-Configuration
 * subtable (edi_document_setup_lines). The master goes through the /tablemaint engine
 * (key 'edi-document-setup'); this service backs the bespoke drawer's option bundle
 * and the lines list + reconcile save (mirrors Custom Chassis Charges).
 */
export interface EdiDocSetupOptions {
  edihandles: string[];
  cmscodes: string[];
  documenttypes: string[];
  billtos: BilltoOpt[];
  customers: CustomerOpt[];
  brokers: BrokerOpt[];
}

export interface DocLine {
  recno: number;
  documenttype: string;
  translationcode: string;
}

export async function getEdiDocSetupOptions(): Promise<EdiDocSetupOptions> {
  const res = await api.get('/edi-document-setup/form-options');
  return res.data as EdiDocSetupOptions;
}

export async function listDocLines(recno: number): Promise<DocLine[]> {
  const res = await api.get(`/edi-document-setup/${recno}/lines`);
  return (res.data?.lines ?? []) as DocLine[];
}

export async function saveDocLines(recno: number, lines: DocLine[], deletes: number[]): Promise<void> {
  await api.put(`/edi-document-setup/${recno}/lines`, { lines, deletes });
}
